/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyQuestionModel } from '../../models/client-survey-question-model';

export interface GetSurveyQuestions$Plain$Params {

/**
 * surveytype id filter
 */
  surveyTypeId: number;
}

export function getSurveyQuestions$Plain(http: HttpClient, rootUrl: string, params: GetSurveyQuestions$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyQuestionModel>>> {
  const rb = new RequestBuilder(rootUrl, getSurveyQuestions$Plain.PATH, 'get');
  if (params) {
    rb.query('surveyTypeId', params.surveyTypeId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientSurveyQuestionModel>>;
    })
  );
}

getSurveyQuestions$Plain.PATH = '/api/SurveyQuestion';
